import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { DepositsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class DepositListBloc extends Bloc<DepositsService['depositControllerGet']> {
    public constructor(service: DepositsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.depositControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
